export default "__VITE_ASSET__B7jkBcBU__"